export default __webpack_public_path__ + "static/media/create-docket.039a827b.gif";